<template>
	<!-- Register Desktop -->
	<section class="login-form">
		<form @submit.prevent>

			<!---  subStep 0 (category - country - entity) -->
			<first-step-register
				v-if="step === 1 && subStep === 0"
				:liveAccount="isLiveAccount"
				@updateCountryEntity="updateCountryEntity"
				@changeViewStep="changeViewStep"
			/>

			<!---  subStep 1 --Entity Information  (textos - checkbox ) -->

			<disclaimer-entity
				v-if="step === 1 && subStep === 1"
				:textEntity="textEntity"
				:isCountryEurope="isCountryEurope"
				@continueDisclaimer="continueDisclaimer"
			/>

			<!---  subStep 2 -- email y password  (google-facebook) -->
			<email-password-register 
				v-if="step === 1 && subStep === 2" 
				:liveAccount="isLiveAccount"
				:title="tittleDinamic"
				:category="accountCategory"
				:email="email"
				@started="started"
			/>

			<!---  step 2 -- Firstname, Lastname -->
			<form-last-step 
				v-if="step === 2"
				:liveAccount="isLiveAccount"
				:title="tittleDinamic"
				:category="accountCategory"
				:firstName="firstName"
				:lastName="lastName"
				@register="register"
			/>

			<!-- Links Sign up -->
			<p v-if="step === 1" class="linkRegistro">
				{{ $t('register.haveAccount') }} &nbsp;
				<a :href="'/login'"> {{ $t('register.signUp') }}</a>
			</p>
		</form>
	</section>
</template>

<script>
import {computed, onMounted, ref, watch } from '@vue/runtime-core'
import { accountService } from '@/_services'
import CountryEntity from '../register/CountryEntity.vue'
import { useRouter, useRoute } from 'vue-router'
import FirstStepRegister from '../register/FirstStepRegister.vue'
import DisclaimerEntity from '../register/DisclaimerEntity.vue'
import EmailPasswordRegister from '../register/EmailPasswordRegister.vue'
import FormLastStep from '../register/FormLastStep.vue'



export default {
	name: 'Form',
	props: {
		step: {
			type: Number,
			required: true,
		},
		email: {
			type: String,
			required: true,
		},
		firstName: {
			type: String,
			required: true,
		},
		lastName: {
			type: String,
			required: true,
		},
	},
	emits: ['started', 'register', 'onError', 'subStep'],
	components: {
		CountryEntity,
		FirstStepRegister,
		DisclaimerEntity,
		EmailPasswordRegister,
		FormLastStep
	},
	setup(props, { emit }) {
		let subStep = ref(0)
		let isLiveAccount = ref(false)
		let tittleDinamic = ref('')
		let isCountryEurope = ref(null)
		let accountCategory = ref(null)
		let countryofRecidency = ref(null)
		let checkRegistration = ref(null)
		const router = useRouter()

		if (accountService.accountValue) {
			router.push('/')
		}

		const textEntity = computed(() => {
			return isCountryEurope.value
				? 'register.entityTextEu'
				: 'register.entityText'
		})

		const updateCountryEntity = (data) => {
			countryofRecidency.value = data.countryofRecidency
			isCountryEurope.value = data.isCountryEurope
			accountCategory.value = data.accountCategory
		}

		const changeViewStep = (value) => {
			subStep.value = value
		}

		const continueDisclaimer = (data) => {
			subStep.value = data.subStep
			checkRegistration.value = data.checkRegistration
		}

		const started = (emailModel, password1, disclaimer) => {
			emit('started', emailModel, password1, disclaimer)
		}

		const register = (emailModel, firstNameModel, lastNameModel, entity) => {
			let disclaimer = true
			emit('register', emailModel, firstNameModel, lastNameModel, accountCategory.value, disclaimer, countryofRecidency.value, entity, checkRegistration.value)
		}

		const accountTypeOpen = () => {
			const path = window.location.pathname.split('/')[4];
			const accountMapping = {
				'live-account': {
					title0: 'register.liveRegistration',
					title: 'register.getYour',
					isLive: true
				},
				'demo-account': {
					title0: 'register.demoRegistration',
					title: 'register.startDemo',
					isLive: false
				}
			};
			if (accountMapping[path]) {
				tittleDinamic.value = accountMapping[path].title;
				isLiveAccount.value = accountMapping[path].isLive;
			}
		};



		onMounted(async () => {
			accountTypeOpen()
		})

		watch(subStep, (newVal) => {
			emit('subStep', newVal)
		})

		return {
			accountTypeOpen,
			tittleDinamic,
			subStep,
			isLiveAccount,
			accountCategory,
			countryofRecidency,
			textEntity,
			checkRegistration,
			isCountryEurope,
			updateCountryEntity,
			changeViewStep,
			continueDisclaimer,
			started,
			register
		}
	},
}
</script>

<style scoped>
.disclaimer-btn .rotate {
	transform: rotate(180deg);
	transition: transform 0.3s;
}
</style>
